import { OrganizationType } from '@evimo/core/modules/organization/domain/OrganizationType';

export const ALLOWED_ORGANIZATION_TYPES: OrganizationType[] = [
  OrganizationType.Operator,
  OrganizationType.Manufacturer,
  OrganizationType.Landlord,
  OrganizationType.OEM,
];
